module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/localLaws.svg?1e294c36";